// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `div.featurestable-frame {
    background-color: var(--list-bg-color);
    overflow: auto;
    border: 1px solid var(--border-color);
    position: relative;
    height: 100%;
}

table.featurestable {
    table-layout: fixed;
    min-width: 100%;
}

table.featurestable th {
    position: sticky;
    z-index: 2;
    padding: 0;
    background-color: var(--button-bg-color);
    color: var(--button-text-color);
    border: 1px solid var(--border-color);
    overflow: hidden;
}

tr.featurestable-header th {
    top: 0;
    height: 2em;
}

tr.featurestable-filterheader th {
    top: calc(2em - 1px);
    font-weight: normal;
    text-align: left;
}

tr.featurestable-filterheader th div.TextInput {
    border: none!important;
}

table.featurestable-selectable tr.featurestable-header th:first-child {
    position: sticky;
    left: 0;
    z-index: 3;
    width: 2em;
}

table.featurestable th::after {
    content: "";
    position: absolute;
    pointer-events: none;
    bottom: 0;
    left: 0;
    right: 0;
    border-bottom: 1px solid var(--border-color);
}

table.featurestable th > span {
    margin: 0 0 -1px -1px;
    padding: 0.25em;
    display: flex;
    align-items: center;
    position: relative;
    white-space: nowrap;
}

table.featurestable th > span > span.icon {
    position: absolute;
    right: 1px;
    background-color: var(--button-bg-color);
    flex: 0 0 auto;
    margin-left: 0.5em;
}

span.featurestable-headername {
    flex: 1 1 auto;
    text-align: left;
    display: flex;
    align-items: center;
}

table.featurestable tr:nth-child(even) {
    background-color: var(--list-item-bg-color-even);
}

table.featurestable tr:hover:not(.row-disabled) {
    background-color: var(--list-item-bg-color-hover);
    color: var(--list-item-text-color-hover);
}

table.featurestable-selectable td:first-child {
    background-color: var(--button-bg-color);
    color: var(--button-text-color);
    padding: 0.25em 0.5em;
    position: sticky;
    left: 0;
    z-index: 1;
    width: 2.5em;
}

table.featurestable-selectable th:first-child::after,
table.featurestable-selectable td:first-child::after {
    content: "";
    position: absolute;
    pointer-events: none;
    right: 0;
    top: 0;
    bottom: 0;
    border-right: 1px solid var(--border-color);
}

table.featurestable td {
    min-width: 2.5em;
    border: 1px solid var(--border-color);
    text-align: center;
    height: 2em;
}

span.featurestable-ldraghandle,
span.featurestable-rdraghandle {
    touch-action: none;
    display: block;
    position: absolute;
    width: 4px;
    top: 0;
    bottom: 0;
    cursor: ew-resize;
}

span.featurestable-ldraghandle {
    left: -1px;
}

span.featurestable-rdraghandle {
    right: 0px;
}

span.featurestable-tdraghandle,
span.featurestable-bdraghandle {
    touch-action: none;
    display: block;
    position: absolute;
    height: 4px;
    left: 0;
    right: 0;
    cursor: ns-resize;
}

span.featurestable-tdraghandle {
    top: -1px;
}

span.featurestable-bdraghandle {
    bottom: 0px;
}

table.featurestable span.icon-checked::before,
table.featurestable span.icon-unchecked::before,
table.featurestable span.icon-tristate::before {
    background-color: white;
}


div.featurestable-resize-line-vert,
div.featurestable-resize-line-horiz {
    position: absolute;
    z-index: 2;
    background-color: var(--border-color);
}

div.featurestable-resize-line-vert {
    width: 4px;
    top: 0;
}

div.featurestable-resize-line-horiz {
    height: 4px;
    left: 0;
}`, "",{"version":3,"sources":["webpack://./qwc2/components/widgets/style/FeaturesTable.css"],"names":[],"mappings":"AAAA;IACI,sCAAsC;IACtC,cAAc;IACd,qCAAqC;IACrC,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,UAAU;IACV,UAAU;IACV,wCAAwC;IACxC,+BAA+B;IAC/B,qCAAqC;IACrC,gBAAgB;AACpB;;AAEA;IACI,MAAM;IACN,WAAW;AACf;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,gBAAgB;IAChB,OAAO;IACP,UAAU;IACV,UAAU;AACd;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,oBAAoB;IACpB,SAAS;IACT,OAAO;IACP,QAAQ;IACR,4CAA4C;AAChD;;AAEA;IACI,qBAAqB;IACrB,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,wCAAwC;IACxC,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,gDAAgD;AACpD;;AAEA;IACI,iDAAiD;IACjD,wCAAwC;AAC5C;;AAEA;IACI,wCAAwC;IACxC,+BAA+B;IAC/B,qBAAqB;IACrB,gBAAgB;IAChB,OAAO;IACP,UAAU;IACV,YAAY;AAChB;;AAEA;;IAEI,WAAW;IACX,kBAAkB;IAClB,oBAAoB;IACpB,QAAQ;IACR,MAAM;IACN,SAAS;IACT,2CAA2C;AAC/C;;AAEA;IACI,gBAAgB;IAChB,qCAAqC;IACrC,kBAAkB;IAClB,WAAW;AACf;;AAEA;;IAEI,kBAAkB;IAClB,cAAc;IACd,kBAAkB;IAClB,UAAU;IACV,MAAM;IACN,SAAS;IACT,iBAAiB;AACrB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,UAAU;AACd;;AAEA;;IAEI,kBAAkB;IAClB,cAAc;IACd,kBAAkB;IAClB,WAAW;IACX,OAAO;IACP,QAAQ;IACR,iBAAiB;AACrB;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,WAAW;AACf;;AAEA;;;IAGI,uBAAuB;AAC3B;;;AAGA;;IAEI,kBAAkB;IAClB,UAAU;IACV,qCAAqC;AACzC;;AAEA;IACI,UAAU;IACV,MAAM;AACV;;AAEA;IACI,WAAW;IACX,OAAO;AACX","sourcesContent":["div.featurestable-frame {\n    background-color: var(--list-bg-color);\n    overflow: auto;\n    border: 1px solid var(--border-color);\n    position: relative;\n    height: 100%;\n}\n\ntable.featurestable {\n    table-layout: fixed;\n    min-width: 100%;\n}\n\ntable.featurestable th {\n    position: sticky;\n    z-index: 2;\n    padding: 0;\n    background-color: var(--button-bg-color);\n    color: var(--button-text-color);\n    border: 1px solid var(--border-color);\n    overflow: hidden;\n}\n\ntr.featurestable-header th {\n    top: 0;\n    height: 2em;\n}\n\ntr.featurestable-filterheader th {\n    top: calc(2em - 1px);\n    font-weight: normal;\n    text-align: left;\n}\n\ntr.featurestable-filterheader th div.TextInput {\n    border: none!important;\n}\n\ntable.featurestable-selectable tr.featurestable-header th:first-child {\n    position: sticky;\n    left: 0;\n    z-index: 3;\n    width: 2em;\n}\n\ntable.featurestable th::after {\n    content: \"\";\n    position: absolute;\n    pointer-events: none;\n    bottom: 0;\n    left: 0;\n    right: 0;\n    border-bottom: 1px solid var(--border-color);\n}\n\ntable.featurestable th > span {\n    margin: 0 0 -1px -1px;\n    padding: 0.25em;\n    display: flex;\n    align-items: center;\n    position: relative;\n    white-space: nowrap;\n}\n\ntable.featurestable th > span > span.icon {\n    position: absolute;\n    right: 1px;\n    background-color: var(--button-bg-color);\n    flex: 0 0 auto;\n    margin-left: 0.5em;\n}\n\nspan.featurestable-headername {\n    flex: 1 1 auto;\n    text-align: left;\n    display: flex;\n    align-items: center;\n}\n\ntable.featurestable tr:nth-child(even) {\n    background-color: var(--list-item-bg-color-even);\n}\n\ntable.featurestable tr:hover:not(.row-disabled) {\n    background-color: var(--list-item-bg-color-hover);\n    color: var(--list-item-text-color-hover);\n}\n\ntable.featurestable-selectable td:first-child {\n    background-color: var(--button-bg-color);\n    color: var(--button-text-color);\n    padding: 0.25em 0.5em;\n    position: sticky;\n    left: 0;\n    z-index: 1;\n    width: 2.5em;\n}\n\ntable.featurestable-selectable th:first-child::after,\ntable.featurestable-selectable td:first-child::after {\n    content: \"\";\n    position: absolute;\n    pointer-events: none;\n    right: 0;\n    top: 0;\n    bottom: 0;\n    border-right: 1px solid var(--border-color);\n}\n\ntable.featurestable td {\n    min-width: 2.5em;\n    border: 1px solid var(--border-color);\n    text-align: center;\n    height: 2em;\n}\n\nspan.featurestable-ldraghandle,\nspan.featurestable-rdraghandle {\n    touch-action: none;\n    display: block;\n    position: absolute;\n    width: 4px;\n    top: 0;\n    bottom: 0;\n    cursor: ew-resize;\n}\n\nspan.featurestable-ldraghandle {\n    left: -1px;\n}\n\nspan.featurestable-rdraghandle {\n    right: 0px;\n}\n\nspan.featurestable-tdraghandle,\nspan.featurestable-bdraghandle {\n    touch-action: none;\n    display: block;\n    position: absolute;\n    height: 4px;\n    left: 0;\n    right: 0;\n    cursor: ns-resize;\n}\n\nspan.featurestable-tdraghandle {\n    top: -1px;\n}\n\nspan.featurestable-bdraghandle {\n    bottom: 0px;\n}\n\ntable.featurestable span.icon-checked::before,\ntable.featurestable span.icon-unchecked::before,\ntable.featurestable span.icon-tristate::before {\n    background-color: white;\n}\n\n\ndiv.featurestable-resize-line-vert,\ndiv.featurestable-resize-line-horiz {\n    position: absolute;\n    z-index: 2;\n    background-color: var(--border-color);\n}\n\ndiv.featurestable-resize-line-vert {\n    width: 4px;\n    top: 0;\n}\n\ndiv.featurestable-resize-line-horiz {\n    height: 4px;\n    left: 0;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
